import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";

export default function SuperAdminAudit() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit-log").then((r) => setLogs(r.data));
  }, []);

  return (
    <AdminLayout>
      <div className="p-8 lg:p-10" data-testid="sa-audit-page">
        <div className="mb-10">
          <div className="overline text-brand mb-2">SuperAdmin · Cross-network</div>
          <h1 className="font-heading font-bold text-4xl tracking-tight">Audit log</h1>
          <p className="text-muted-foreground mt-2">Tracking di tutte le operazioni cross-network. Ultimi 100 eventi.</p>
        </div>

        <div className="bg-white border border-border rounded-sm overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-[#FAFAFA] border-b border-border">
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Timestamp</th>
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">User</th>
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Action</th>
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Entity</th>
                <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">ID</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-border last:border-0 hover:bg-accent/30" data-testid={`audit-row-${l.id}`}>
                  <td className="px-5 py-3 text-xs font-mono text-muted-foreground">
                    {l.timestamp ? new Date(l.timestamp).toLocaleString() : "—"}
                  </td>
                  <td className="px-5 py-3 text-sm">{l.user_email || "system"}</td>
                  <td className="px-5 py-3">
                    <span className="px-2 py-0.5 text-xs rounded-full bg-accent font-mono">{l.action}</span>
                  </td>
                  <td className="px-5 py-3 text-sm">{l.entity_type}</td>
                  <td className="px-5 py-3 text-xs font-mono text-muted-foreground">{(l.entity_id || "").slice(0, 8)}…</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr><td colSpan={5} className="px-5 py-10 text-center text-sm text-muted-foreground">Nessun evento ancora registrato.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
